import axios from 'axios';

export const authService = {
    /** Active Payroll */
    getActivePayrollService: (params) => axios.get('/payroll/timesheet/active', { auth: true, params: { ...params } }),

    createProcessPayrollService: (ids, params) => axios.post('/payroll/timesheet/process', ids, { auth: true, params: { ...params } }),

    getPayrollByIdService: (id) => axios.get(`/payroll/timesheet/${id}`, { auth: true }),

    deletePayrollService: (id) => axios.delete(`/payroll/timesheet/${id}`, { auth: true }),

    resolvePayrollService: (id, params) => axios.patch(`/payroll/timesheet/${id}/resolve`, null, { auth: true, params: { ...params } }),
    /** End */

    /** Processed Payroll */

    getProcessedPayrollService: (params) => axios.get('/payroll/timesheet/processed', { auth: true, params: { ...params } }),

    getProcessedPayrollBatchesService: (params, id) => axios.get(`/payroll/timesheet/byBatch/${id}`, { auth: true, params: { ...params } }),

    unProcessPayrollService: (ids) => axios.post('/payroll/timesheet/un-process', { batchIds: ids }, { auth: true }),

    /** End */
};
